module.exports = __webpack_public_path__ + "img/logo-journey-full.e323b202.svg";